import { render, staticRenderFns } from "./surveyQuizeDetail.vue?vue&type=template&id=79a91492&scoped=true"
import script from "./surveyQuizeDetail.vue?vue&type=script&lang=js"
export * from "./surveyQuizeDetail.vue?vue&type=script&lang=js"
import style0 from "./surveyQuizeDetail.vue?vue&type=style&index=0&id=79a91492&prod&lang=scss&scoped=true"
import style1 from "./surveyQuizeDetail.vue?vue&type=style&index=1&id=79a91492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a91492",
  null
  
)

export default component.exports